import { SettingLayoutComponentId } from '@starsoft/common/models';
import { useComponentVariant } from '../../useComponentVariant';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';

export default function useHomeHeroComponent() {
  const version: string =
    useComponentVariant(ComponentTypeId.HomeHero) ??
    SettingLayoutComponentId.HomeHeroV1.toString();

  return version;
}
